import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from '@angular/core';
import { HelperServiceService } from '../../../../../utils/helper-service.service';
import { CommonModule } from '@angular/common';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { environment } from '../../../../../../environments/environment';
import { CourseService } from '../../../../../pages/courses/course.service';
import { ToasterService } from '../../../../../providers/toaster/toaster.service';
import { ConfomerService } from '../../../../../providers/confomer/confomer.service';
import { Store } from '@ngrx/store';
import { selectCourseId } from '../../../../../pages/courses/create-courses/store/course.selector';
import { take } from 'rxjs';
import { CourseHelperServiceService } from '../../../../../pages/courses/course-helper-service.service';
import { CustomValidatorsService } from '../../../../../utils/customFormValidator.service';
import { urlPattern } from '../../../../../providers/regexPattern';
import { NonNegativeDirective } from "../../../../../utils/non-negative.directive";
import {
  videoTitleAllowedCharsValidator,
  videoTitleMinLengthValidator,
  videoTitleMaxLengthValidator,
  videoTitleNoAllSpacesValidator,
  videoTitleTrimValidator,
  theoryMinLengthValidator,
  theoryMaxLengthValidator,
  theoryNoAllSpacesValidator,
  nonNegativeIntegerDigitsValidator,
  nonNegativeIntegerMinValidator,
  videoLinkMaxLengthValidator,
  videoLinkValidator
} from '../../../../../utils/create_course_validators/structure/videoChapterValidators';

@Component({
  selector: 'app-video-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NonNegativeDirective, CdkDragHandle],
  templateUrl: './video-form.component.html',
  styleUrl: './video-form.component.css'
})
export class VideoFormComponent implements OnChanges {
  @Input() data: any
  @Input() index: any
  @Input() coursePublished: boolean = false

  courseId: any
  subjectId: any

  videoData: any
  thumbnail: File | null = null;
  thumbnailUrl: string | ArrayBuffer | null = null;
  videoForm!: FormGroup
  isPreview: boolean = true
  flag: number = 0
  hasTheory: boolean = false

  isSubmitting = false;

  constructor(private helperService: HelperServiceService, private fb: FormBuilder,

    private courseApiService: CourseService, private toasterService: ToasterService,
    private conformDialog: ConfomerService, private store: Store, private couserHelper: CourseHelperServiceService,
    private customeValidator: CustomValidatorsService
  ) {
    this.videoForm = this.fb.group({
      id: [0],
      course_id: [0, Validators.required],
      structure_id: [0, Validators.required],
      video_title: ['', [
        Validators.required,
        videoTitleMinLengthValidator(3),
        videoTitleMaxLengthValidator(150),
        videoTitleAllowedCharsValidator(),
        videoTitleNoAllSpacesValidator(),
        videoTitleTrimValidator()
      ]],

      video_link: ['', [
        videoLinkValidator(),
        videoLinkMaxLengthValidator(500)
      ]],
      video_file: [''],
      video_lock: this.fb.control<string[]>([]),
      is_reel_link: [false],
      video_duration: [0, Validators.required],
      theory: ['', [
        theoryMinLengthValidator(10),
        theoryMaxLengthValidator(5000),
        theoryNoAllSpacesValidator()
      ]],
      theory_lock: this.fb.control<string[]>([]),
      thumbnail: [''],
      thumbnail_lock: this.fb.control<string[]>([]),
      no_of_views: ['', [
        Validators.required,
        nonNegativeIntegerDigitsValidator(),
        nonNegativeIntegerMinValidator(0)
      ]],
      views_lock: this.fb.control<string[]>([]),
      price: ['', [
        Validators.required,
        nonNegativeIntegerDigitsValidator(),
        nonNegativeIntegerMinValidator(0)
      ]],
    });
  }


  ngOnInit(): void {
    this.store.select(selectCourseId).pipe(take(1)).subscribe(value => {
      this.courseId = value
    })
    this.initializeComponentData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Detect when parent passes new data after API submission
    if (changes['data'] && changes['data'].currentValue) {
      this.initializeComponentData();
    }
  }

  private initializeComponentData() {
    this.isPreview = this.data?.video?.isEditing ? false : true || false
    this.subjectId = this.data?.structure_id
    this.flag = this.data?.video?.flag ?? 0
    this.videoData = this.data?.video
    this.patchValues(this.videoData)
    console.log(this.flag);
    if (this.flag == 1) {
      this.videoForm.setValidators(this.customeValidator.atLeastOneFieldFilled('video_link', 'video_file'));
      this.videoForm.updateValueAndValidity();
    }
  }




  ngAfterViewInit(): void {

  }



  patchValues(data: any) {
    this.videoForm.patchValue({
      id: data.id ?? 0,
      course_id: this.courseId ?? 0,
      structure_id: this.subjectId ?? 0,
      video_title: data.video_title ?? '',
      video_link: data.video_link ?? '',
      video_lock: this.couserHelper.toArray(data.video_lock),
      is_reel_link: data.is_reel_link ?? false,
      video_duration: data.video_duration ?? 0,
      theory: data.theory ?? '',
      theory_lock: this.couserHelper.toArray(data.theory_lock),
      thumbnail_lock: this.couserHelper.toArray(data.thumbnail_lock),
      no_of_views: data.no_of_views ?? '',
      views_lock: this.couserHelper.toArray(data.views_lock),
      price: data.price ?? '',
    });
    console.log(this.videoForm.value);
    this.thumbnailUrl = data?.thumbnail ?? ''
    this.hasTheory = data?.theory ? true : false
    if (this.videoData?.false == 0) {
    }

  }

  addVideoStructure() {
    if (this.isSubmitting) return;
    if (this.videoForm.invalid) {

      this.videoForm.markAllAsTouched();
      console.log(this.videoForm);
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields correctly.');
      return;
    }
    console.log(this.videoForm.value);
    this.isSubmitting = true;
    const formData = this.createFormData(this.videoForm.value);
    console.log(formData);
    this.courseApiService.addVideoNode(formData).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Video Added', res.body.message);
          this.isPreview = true;
          this.patchValues(this.videoForm.value);
          this.emitData('get_data');
        }
      } catch (error) {
        this.toasterService.setToaster('error', 'video failed to add', res?.body?.message);
      } finally {
        this.isSubmitting = false;
      }
    }, () => {
      this.isSubmitting = false;
    })

  }


  UpdateVideoStructure() {
    if (this.isSubmitting) return;
    console.log(this.videoForm.value);


    if (this.videoForm.invalid) {
      this.videoForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields correctly.');
      return;
    }
    console.log(this.videoForm.value);
    this.isSubmitting = true;
    const formData = this.createFormData(this.videoForm.value);
    formData.delete('id');
    let id = this.videoForm.value.id
    this.courseApiService.updateVideoNode(formData, id).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Video Added', res.body.message);
          this.isPreview = true;
          this.patchValues(this.videoForm.value);
          this.emitData('get_data');
        }
      } catch (error) {
        this.toasterService.setToaster('error', 'video failed to add', res?.body?.message);
      } finally {
        this.isSubmitting = false;
      }
    }, () => {
      this.isSubmitting = false;
    })
  }


  async deleteVideoStructure(id: any) {
    console.log(id);
    let confirm = await this.conformDialog.Open('Delete Video', 'Are you sure you want to delete this video?');
    if (confirm) {
      this.courseApiService.deleteVideoNode(id).subscribe((res: any) => {
        try {
          if (res.body.status == "success") {
            this.toasterService.setToaster('success', 'Video Deleted', res.body.message);
            this.emitData('get_data');
          }
        } catch (error) {
          this.toasterService.setToaster('error', 'video failed to delete', res.body.message);
        }
      })
    }


  }
  // delete video structure from store which is greated newly
  deleteVideoStructureNew() {
    this.emitData('delete_video_structure', this.index);
  }

  createFormData(data: any): FormData {





    const formData = new FormData();

    // Primitive fields
    formData.append('course_id', data.course_id);
    formData.append('structure_id', data.structure_id);
    // formData.append('id', data.id);
    formData.append('video_title', data.video_title);
    formData.append('video_link', data.video_link);
    formData.append('video_duration', data.video_duration);
    formData.append('theory', data.theory);
    formData.append('no_of_views', data.no_of_views);
    formData.append('price', data.price);
    formData.append('is_reel_link', data.is_reel_link ? '1' : '0');
    formData.append('thumbnail', data.thumbnail ?? null);
    formData.append('video_file', data.video_file ?? null);
    formData.append('is_active', '1');

    // formData.append('video_lock[]', JSON.stringify(data.video_lock || []));
    // formData.append('theory_lock[]', JSON.stringify(data.theory_lock || []));
    // formData.append('thumbnail_lock[]', JSON.stringify(data.thumbnail_lock || []));
    // formData.append('views_lock[]', JSON.stringify(data.views_lock || []));

    (data.video_lock ?? []).forEach((item: string) => {
      formData.append('video_lock[]', item);
    });

    (data.theory_lock ?? []).forEach((item: string) => {
      formData.append('theory_lock[]', item);
    });

    (data.thumbnail_lock ?? []).forEach((item: string) => {
      formData.append('thumbnail_lock[]', item);
    });

    (data.views_lock ?? []).forEach((item: string) => {
      ``
      formData.append('views_lock[]', item);
    });

    return formData;
  }





  setLockStatus(e: Event, formControlName: string) {
    const checkbox = e.target as HTMLInputElement;
    const value = checkbox.value;
    const currentArray = this.videoForm.value[formControlName] || [];

    if (checkbox.checked) {
      if (!currentArray.includes(value)) {
        this.videoForm.patchValue({
          [formControlName]: [...currentArray, value]
        });
      }
    } else {
      this.videoForm.patchValue({
        [formControlName]: currentArray.filter((item: string) => item !== value)
      });
    }
  }

  setVideoFIle(e: Event) {
    // Use helper service only for duration extraction if implemented elsewhere.
    // Current helper signature is for image thumbnail uploads; keep existing behavior if needed.
    this.helperService.getImageWithAspectCheck(e, 'none').then(({ video, duration }) => {
      if (video) {
        this.videoForm.get('video_file')?.setValue(video);
        this.videoForm.get('video_duration')?.setValue(duration.toFixed(0));
      }
    });
  }

  onFileSelected(e: Event): void {
    this.helperService.getImageWithAspectCheck(e, 'square').then(({ image, imageUrl }) => {
      if (image) {
        this.thumbnail = image;
        this.videoForm.get('thumbnail')?.setValue(this.thumbnail);
        this.thumbnailUrl = imageUrl;
      }
    })
  }

  closePreview() {
    this.isPreview = true
    this.patchValues(this.videoData)
  }

  @Output() dataEvent = new EventEmitter<any>();

  emitData(action: string,index?: any) {
    let data = {
      action: action,
      index: index ?? null,
    }
    this.dataEvent.emit(data);
  }


}
